export class SelectedProductQuoteFTRP {
    constructor(
        public pensionFund: string = null,
        public startDate: string = null,
        public income: string = null,
        public incomeIncrease: string = null,
        public totalTaxFreeCashAmount: string = null,
        public incomeDependent: string = null,
        public guaranteedTerm: number = null,
        public guaranteedTermIndicator: string = null,
        public guarantedPaymentPeriod: string = null,
        public valueProtection: string = null,
        public valueProtectionAmount: number = null,
        public quoteExpiry: number = null,
        public monthlyIncome: number = null,
        public annualIncome: number = null,
        public padsRefNo: string = null,
        public paymentFrequency: string = null,
        public selectedProduct: string = null,
        public fundingSource: string = null,
        public quoteRefNo: string = null,
        public initialAnnualIncome: number = null,
        public annuitantYearlyPension: number = null,
        public annuitantPension: number = null,
        public annuitantMaturity: number = null,
        public policyTerm: number = null,
        public policyTermMonths: number = null,
        public maturityAmount: number = null,
        public giaCalculated: string = null,
        public applicationId: string = null,
        public productOptions: string = null,
        public requoteInd: string = null,
        public applyQuoteInd: string = null ) {
    }
}
